import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ServiceSparkModel } from '../../../core/api/models';

@Component({
  selector: 'app-session-service-select',
  templateUrl: './session-service-select.component.html',
  standalone: false,
})
export class SessionServiceSelectComponent {
  @Input() services: ServiceSparkModel[] = [];
  @Input() serviceId: number | null = null;
  @Input() placeholder = 'Create without linking';
  @Input() inputId = 'sessionServiceSelect';
  @Input() loading = false;
  @Output() serviceIdChange = new EventEmitter<number | null>();

  get serviceMap(): { [id: number]: ServiceSparkModel } {
    const map: { [id: number]: ServiceSparkModel } = {};
    (this.services ?? []).forEach((service) => {
      if (service.ID) {
        map[service.ID] = service;
      }
    });
    return map;
  }

  get serviceOptions(): SelectItem[] {
    return (this.services ?? [])
      .filter((service) => !!service.ID)
      .map((service) => ({
        label: 'Service #' + service.ID,
        value: service.ID,
      }));
  }

  onServiceIdChange(serviceId: number | null): void {
    this.serviceId = serviceId;
    this.serviceIdChange.emit(serviceId);
  }
}
